export default __webpack_public_path__ + "static/media/BootsSharp-Bold1.c26c3482.svg";